"use strict";

exports.__esModule = true;
exports.getRelativeKeys = getRelativeKeys;
exports.getNestCachePath = getNestCachePath;
exports.getNestWatchPath = getNestWatchPath;
exports.wrapFunction = wrapFunction;
exports.processRelativeKey = processRelativeKey;
exports.processNestWatcherKey = processNestWatcherKey;

var _nestWatcher = require("../../../models/nest-watcher");

var _types = require("../types");

function getRelativeKeys(node) {
  return node.getPathKeys(function (node) {
    var _node$getValue = node.getValue(),
        type = _node$getValue.type,
        repeat = _node$getValue.repeat,
        field = _node$getValue.field;

    if (type === _types.FormNodeType.ROOT) {
      return null;
    }

    if (node.parentNode && repeat) {
      return String(node.parentNode.getIndex(node));
    }

    return field !== '' ? field : null;
  });
}

function getNestCachePath(node) {
  var res = [];
  var found = false;
  node.getPathKeys(function (node) {
    var _node$getValue2 = node.getValue(),
        field = _node$getValue2.field,
        cache = _node$getValue2.cache;

    if (found) {
      return null;
    }

    if (cache != null) {
      found = true;
      return null;
    }

    if (field) {
      res.unshift(field);
    }

    return null;
  });

  if (!found) {
    return [];
  }

  return res;
}

function getNestWatchPath(node) {
  var res = [];
  node.getPathKeys(function (node) {
    var _node$getValue3 = node.getValue(),
        repeat = _node$getValue3.repeat,
        field = _node$getValue3.field;

    if (node.parentNode && repeat) {
      res = [];
    } else if (field) {
      res.unshift(field);
    }

    return null;
  });
  return res;
}

function wrapFunction(func) {
  return function () {
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var ret = func.call.apply(func, [null].concat(args));

      if (ret != null && typeof ret === 'object' && typeof ret.then === 'function') {
        return ret;
      }

      return Promise.resolve(ret);
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

function processRelativeKey(node, key) {
  if (/^\.\//.test(key)) {
    key = key.slice(2);
    var scopeKeys = getRelativeKeys(node);
    return _nestWatcher.NestWatcher.combineKeys([].concat(scopeKeys, _nestWatcher.NestWatcher.splitKey(key)));
  }

  if (/^\.\.\//.test(key)) {
    var _scopeKeys = getRelativeKeys(node);

    while (/^\.\.\//.test(key)) {
      _scopeKeys.pop();

      key = key.slice(3);
    }

    return _nestWatcher.NestWatcher.combineKeys([].concat(_scopeKeys, _nestWatcher.NestWatcher.splitKey(key)));
  }

  return key;
}

function processNestWatcherKey(node, key) {
  if (/^\.\//.test(key)) {
    return _nestWatcher.NestWatcher.combineKeys(getNestWatchPath(node));
  }

  if (/^\.\.\//.test(key)) {
    var scopeKeys = getRelativeKeys(node);
    var nestKeys = getNestWatchPath(node);

    while (/^\.\.\//.test(key)) {
      key = key.slice(3);
      scopeKeys.pop();
    }

    return _nestWatcher.NestWatcher.combineKeys(scopeKeys.length < nestKeys.length ? scopeKeys : nestKeys);
  }

  return key;
}